module.exports = __webpack_public_path__ + "static/img/gx.412e089.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/images/gx.png
// module id = 1012
// module chunks = 1